module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-garda.svg?3e0259cb8c06da1fdc0139b380a19624";